import { render, staticRenderFns } from "./StudentExchangeInformationColumnWidget.vue?vue&type=template&id=26b4275c&"
import script from "./StudentExchangeInformationColumnWidget.vue?vue&type=script&lang=ts&"
export * from "./StudentExchangeInformationColumnWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports